import { takeLatest, fork, put, all, call } from "redux-saga/effects"
import i18n from "i18n"
import { API } from "api"
import { staticPagesData } from "./slice"

export function* getData({ payload: { id } }) {
  try {
    const response = yield call(API.admin.getStaticPageById, id)

    const { data } = response

    yield put(staticPagesData.getDataCompleted(data))
  } catch (error) {
    const message = error.response?.data?.message || i18n.t("error")
    yield put(staticPagesData.getDataRejected(message))
  }
}

export function* watchGetData() {
  yield takeLatest(staticPagesData.getData, getData)
}

function* dataSaga() {
  yield all([fork(watchGetData)])
}

export default dataSaga
